"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptiveTest = void 0;
const initialization_1 = require("./initialization");
const selection_1 = require("./selection");
const stopping_1 = require("./stopping");
const initialD_1 = require("./initialD");
const irt_1 = require("./irt");
// Adds the CPU backend to the global backend registry.
require("@tensorflow/tfjs-backend-cpu");
const matricesGeneration_1 = require("./matricesGeneration");
const ATM_1 = __importDefault(require("./ATM"));
var tf = require("@tensorflow/tfjs-core");
var log_params = {
    toLogInFile: false,
    toPrint: false,
    fileToLogIn: "LogFile.json",
    toLog: {
        debug_general: [0],
    },
};
class AdaptiveTest extends ATM_1.default {
    /**
     * Class that handles the adaptive test
     * @param params : config object (same as in the BM)
     * @param history : histroy of the BM if we want to exploit it (in case the test is launched in the middle or
     * at the end of a module)
     * @param discriminations : discriminations of all items in the test bank
     * @param difficulties : difficulties of all items in the test bank
     */
    constructor(config, bo = 1, nbMinQuestions = 0, nbMaxQuestions = 20, log_def = undefined, difficulties = undefined, history = undefined, discriminations = undefined, kFirst = 4) {
        //constructor(params: any, parametricGraph: { [id: string]: any; }, bo: number = 1, log_def: any = undefined, difficulties: { [id: string]: number; } = undefined, history: any = undefined, discriminations: { [id: string]: number[]; } = undefined, kFirst: number = 4) {
        super(config, bo, nbMinQuestions, nbMaxQuestions, difficulties, history, discriminations, kFirst);
        this.bad_answers = []; // ensemble des activités auquels l'élève à répondu faux
        this.good_answers = []; // ensemble des activités auquels l'élève à répondu juste
        this.seen_act = new Set(); // liste contenant les activités déjà évalué par le test adptatif
        this.seen_onces = []; // activities that have been seen at least once (usefull if bo != 1)
        if (log_def != undefined) {
            for (let key in log_def) {
                if (["toLogInFile", "toPrint"].includes(key)) {
                    this.log_params[key] = log_def[key];
                    log_params[key] = log_def[key];
                }
                else if (key == "toLog") {
                    for (let logKey in log_def[key]) {
                        this.log_params[key][logKey] = log_def[key][logKey];
                        log_params[key][logKey] = log_def[key][logKey];
                    }
                }
            }
        }
        if (!difficulties) {
            this.difficulties = (0, matricesGeneration_1.generateDifficultiesAct)(this.ontology.objectives, this.ontology.activitiesOfObj);
        }
        if (difficulties) {
            this.difficulties = difficulties;
        }
        let tmp = (0, matricesGeneration_1.generateDiscriminationsPrerequisite)(this.params, this.parametricGraph, this.ontology.objectives, this.ontology.activitiesOfObj);
        this.discriminations_anc = tmp[0];
        this.discriminations_no_anc = tmp[1];
        this.numberOfKcs = Object.values(this.discriminations_anc)[0].length;
        this.initializer = new initialization_1.FixedPointInitializer(0, this.numberOfKcs);
        this.selector = new selection_1.MaxInfoDetSelector(this.numberOfKcs);
        this.InformationMatrix = tf.tensor(new Array(this.numberOfKcs).fill(0));
        this.thetaEstimation = this.initializer.initialize();
        this.IdKFirst = this.sampleKfirst();
        this.bo = bo;
        this.identical_ans_needed = ((bo / 2) | 0) + 1;
        this.ancestors = (0, matricesGeneration_1.generateAncestorByAct)(this.params, this.ontology.activitiesOfObj, this.parametricGraph);
        this.descendants = (0, matricesGeneration_1.generateDescendantByAct)(this.params, this.ontology.activitiesOfObj, this.parametricGraph);
        this.stopper = new stopping_1.MaxItemStopper(this.nbMaxQuestions);
        this.all_activities_seen = false;
    }
    /**
     * Vérifie si le test doit s'arrêter
     * @returns true si le test doit s'arrêter
     */
    isTestFinished() {
        if (!this.all_activities_seen) {
            this.all_activities_seen =
                this.seen_act.size == this.ontology.get_number_of_activities(); //Vérifier si le test doit s'arrêter
        }
        return ((this.stopper.stop(this.actSequence["act"]) ||
            this.all_activities_seen) &&
            this.actSequence["act"].length >= this.nbMinQuestions);
    }
    /**
     * select next activity
     * @returns moduleId, objectiveId, activityId
     */
    nextActivity() {
        let actID = this.sample();
        let objID = this.ontology.get_objectiveID_of_activity(actID);
        let output = {
            moduleId: this.main_act,
            objectiveId: objID,
            activityId: actID,
            isAdaptiveTest: true,
        };
        return output;
    }
    update(lastInteraction) {
        if (Object.keys(lastInteraction).length) {
            this.base_update(lastInteraction);
            this.update_mastery();
            this.thetaEstimation = this.estimate(); //estimation du niveau de l'élève
            this.updateInfoMatrix(); //mise à jour de la matrice de l'information de Fischer
        }
    }
    isCurriculumFinished() {
        return this.isTestFinished();
    }
    /**
     *
     * @returns la prochaine question à poser
     * au début retourne les questions non adaptatives puis enchaîne avec des .select()
     */
    sample() {
        if (this.actSequence["act"].length < this.IdKFirst.length) {
            let candidateAct = [];
            for (let i = 0; i < this.actSequence["weight"].length; i++) {
                if (this.actSequence["weight"][i] == 1) {
                    candidateAct.push(this.actSequence["act"][i]);
                }
            }
            for (let actId of this.IdKFirst) {
                //sélection des n (4) premières questions
                if (!candidateAct.includes(actId) && !this.seen_act.has(actId)) {
                    return actId;
                }
            }
        }
        return this.select();
    }
    /**
     * method which selects the next item to be asked in the test
     * @returns list of id activity ordered by the selector value
     */
    select() {
        let fisherDet = this.selector.select(this.discriminations_anc, this.difficulties, this.thetaEstimation, this.InformationMatrix, this.discriminations_no_anc);
        for (let seen of this.seen_onces) {
            fisherDet[seen] /= 2;
        }
        let sorted = Object.entries(fisherDet)
            .sort((a, b) => b[1] - a[1])
            .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
        }, {});
        let actIds = Object.keys(sorted);
        if (!this.all_activities_seen) {
            for (let actId of actIds) {
                // return a random exercice from the first activity that hasn't been seen yet
                if (!this.seen_act.has(actId)) {
                    return actId;
                }
            }
        }
        else
            return actIds[0];
    }
    /**
     * Check if an activity and its ancestors or descendants are mastered or not
     * Based on the BO parameter
     */
    update_mastery() {
        const cur_act = this.actSequence["act"].at(-1);
        const isCorrect = this.actSequence["res"].at(-1);
        const cur_obj = this.ontology.get_objectiveID_of_activity(cur_act);
        const pos_act = this.ontology.get_activity_position_in_obj(cur_act);
        const minQuestionsMet = this.actSequence["res"].length === this.nbMinQuestions;
        // Helper function to update mastery level
        const updateMasteryLevel = (cur_act, adjustment, relatedActivities, isAncestor) => {
            var _a;
            this.seen_act.add(cur_act);
            this.lvl_per_obj[cur_obj][pos_act] += adjustment;
            if ((_a = relatedActivities[cur_act]) === null || _a === void 0 ? void 0 : _a.length) {
                this.update_related_activities_mastery(cur_act, relatedActivities, isAncestor ? 1 : 0);
            }
        };
        // Update counts and BO_act based on response
        this.count_act[cur_act] += 1;
        this.BO_act[cur_act] += isCorrect ? 1 : -1;
        // Record the answer
        (isCorrect ? this.good_answers : this.bad_answers).push(cur_act);
        if (minQuestionsMet) {
            this.BO_projection();
        }
        const currentBO = this.BO_act[cur_act];
        const conditionMet = Math.abs(currentBO) === this.identical_ans_needed ||
            (Math.abs(currentBO) === this.identical_ans_needed - 1 &&
                this.count_act[cur_act] === this.bo);
        if (conditionMet && this.actSequence["res"].length > this.nbMinQuestions) {
            updateMasteryLevel(cur_act, isCorrect ? 1 : -1, isCorrect ? this.ancestors : this.descendants, isCorrect);
        }
    }
    update_related_activities_mastery(current_activity, related_activities, last_answer) {
        const coeff = last_answer > 0 ? 1 : -1;
        const related = related_activities[current_activity] || [];
        related.forEach((activity) => {
            if (activity !== current_activity) {
                this.count_act[activity] += 1;
                this.BO_act[activity] += coeff;
                if (!this.seen_onces.includes(activity)) {
                    this.seen_onces.push(activity);
                }
                const currentBO = Math.abs(this.BO_act[activity]);
                const conditionMet = (currentBO >= this.identical_ans_needed ||
                    (currentBO >= this.identical_ans_needed - 1 &&
                        this.count_act[activity] >= this.bo)) &&
                    !this.seen_act.has(activity);
                if (conditionMet) {
                    const indexOfAct = this.ontology.get_activity_position_in_obj(activity);
                    const obj = this.ontology.get_objectiveID_of_activity(activity);
                    this.seen_act.add(activity);
                    this.lvl_per_obj[obj][indexOfAct] += coeff;
                }
            }
        });
    }
    BO_projection() {
        const { act, res } = this.actSequence;
        for (let i = 0; i < act.length; i++) {
            const activity = act[i];
            const isCorrect = res[i] > 0;
            const relatedActivities = isCorrect ? this.ancestors : this.descendants;
            for (const relatedActivity of relatedActivities[activity] || []) {
                if (relatedActivity !== activity) {
                    this.count_act[relatedActivity] += 1;
                    this.BO_act[relatedActivity] += isCorrect ? 1 : -1;
                }
            }
        }
        for (const act in this.BO_act) {
            const currentBO = this.BO_act[act];
            const cur_obj = this.ontology.get_objectiveID_of_activity(act);
            const pos_act = this.ontology.get_activity_position_in_obj(act);
            const conditionMet = Math.abs(currentBO) >= this.identical_ans_needed ||
                (Math.abs(currentBO) >= this.identical_ans_needed - 1 &&
                    this.count_act[act] >= this.bo);
            if (conditionMet) {
                this.seen_act.add(act);
                this.lvl_per_obj[cur_obj][pos_act] += currentBO > 0 ? 1 : -1;
            }
        }
    }
    /**
     * estimate the new student level (theta)
     * @returns a new value for theta
     */
    estimate() {
        if (this.good_answers.length > 0 && this.bad_answers.length > 0) {
            // on calcule deux théta, un pour l'ensemble des réponses juste et l'autre pour les réponses négatif
            let thetaGood = this.estimator.estimate(this.discriminations_anc, this.difficulties, this.good_answers, new Array(this.good_answers.length).fill(1), tf.tensor(this.thetaEstimation), new Array(this.good_answers.length).fill(1));
            let thetaBad = this.estimator.estimate(this.discriminations_no_anc, this.difficulties, this.bad_answers, new Array(this.bad_answers.length).fill(0), tf.tensor(this.thetaEstimation), new Array(this.bad_answers.length).fill(1));
            let new_theta = this.initializer.initialize();
            for (let i = 0; i < this.thetaEstimation.length; i++) {
                new_theta[i] = thetaGood[i] + thetaBad[i];
            }
            return new_theta;
        }
        else if (this.good_answers.length > 0 && this.bad_answers.length == 0) {
            return this.estimator.estimate(this.discriminations_anc, this.difficulties, this.good_answers, new Array(this.good_answers.length).fill(1), tf.tensor(this.thetaEstimation), new Array(this.good_answers.length).fill(1));
        }
        else {
            return this.estimator.estimate(this.discriminations_no_anc, this.difficulties, this.bad_answers, new Array(this.bad_answers.length).fill(0), tf.tensor(this.thetaEstimation), new Array(this.bad_answers.length).fill(1));
        }
    }
    /**
     * method which samples the first k activity to ask in the test according to a DPP
     * @returns first k activity to ask in the test
     */
    sampleKfirst() {
        const V = (0, matricesGeneration_1.extractRandomInversibleSubmatrix)(this.discriminations_anc);
        let kActivities_anc = (0, initialD_1.kSample)(Array.from(Object.keys(V)), tf
            .dot(Array.from(Object.values(V)), tf.transpose(Array.from(Object.values(V))))
            .arraySync(), this.kFirst);
        if (!kActivities_anc) {
            return this.sampleKfirst();
        }
        const V_no_anc = (0, matricesGeneration_1.extractRandomInversibleSubmatrix)(this.discriminations_no_anc);
        let kActivities_no_anc = (0, initialD_1.kSample)(Array.from(Object.keys(V_no_anc)), tf
            .dot(Array.from(Object.values(V_no_anc)), tf.transpose(Array.from(Object.values(V_no_anc))))
            .arraySync(), this.kFirst);
        if (!kActivities_no_anc) {
            return this.sampleKfirst();
        }
        let actId = [];
        if (kActivities_anc.length >= this.kFirst) {
            for (let i = this.kFirst - 1; i >= this.kFirst / 2; i--) {
                actId.push(kActivities_anc[i]);
            }
        }
        else {
            for (let i = 0; i < Math.min(this.kFirst / 2, kActivities_anc.length); i++) {
                actId.push(kActivities_anc[i]);
            }
        }
        for (let i = 0; i < Math.min(this.kFirst / 2, kActivities_no_anc.length); i++) {
            actId.push(kActivities_no_anc[i]);
        }
        return actId;
    }
    /**
     * method which updates the information matrix of the test depending on the history of responses and theta
     * estimation
     */
    updateInfoMatrix() {
        var reducedExSequence = [];
        for (let j = 0; j < this.actSequence["act"].length; j++) {
            if (this.actSequence["weight"][j] == 1) {
                reducedExSequence.push(this.actSequence["act"][j]);
            }
        }
        if (this.actSequence["res"].at(-1)) {
            this.InformationMatrix = (0, irt_1.hessian)(this.thetaEstimation, this.discriminations_anc, this.difficulties, reducedExSequence, 0.25);
        }
        else {
            this.InformationMatrix = (0, irt_1.hessian)(this.thetaEstimation, this.discriminations_no_anc, this.difficulties, reducedExSequence, 0.25);
        }
    }
}
exports.default = AdaptiveTest;
exports.AdaptiveTest = AdaptiveTest;
